import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const columnData = [
	{
		id: 'name',
		numeric: false,
		disablePadding: false,
		label: 'Location',
	},
	{
		id: 'province',
		numeric: false,
		disablePadding: false,
		label: 'Province',
	},
	{ id: 'rating', numeric: true, disablePadding: false, label: 'Rating' },
	{
		id: 'totalReviewCount',
		numeric: true,
		disablePadding: true,
		label: 'Reviews',
	},
	{
		id: 'desktopSearchViews',
		numeric: true,
		disablePadding: true,
		label: 'Desktop Views',
	},
	{
		id: 'mobileSearchViews',
		numeric: true,
		disablePadding: true,
		label: 'Mobile Views',
	},
	{
		id: 'websiteActions',
		numeric: true,
		disablePadding: true,
		label: 'Web Visits',
	},
	{
		id: 'mapsViews',
		numeric: true,
		disablePadding: true,
		label: 'Maps',
	},
	{
		id: 'phoneActions',
		numeric: true,
		disablePadding: true,
		label: 'Calls',
	},
];

class EnhancedTableHead extends React.Component {
	createSortHandler = (property) => (event) => {
		this.props.onRequestSort(event, property);
	};

	render() {
		const { order, orderBy } = this.props;
		const provinceLabel = this.props.provinceLabel || 'Province';

		return (
			<TableHead>
				<TableRow>
					{columnData.map((column) => (
						<TableCell
							key={column.id}
							numeric={column.numeric}
							align={column.numeric ? 'right' : 'left'}
							sortDirection={orderBy === column.id ? order : false}
							data-column={column.id}
						>
							<TableSortLabel
								active={orderBy === column.id}
								direction={order}
								onClick={this.createSortHandler(column.id)}
							>
								{column.id === 'province'
									? provinceLabel
									: column.label}
							</TableSortLabel>
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}
}

EnhancedTableHead.propTypes = {
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.string.isRequired,
	orderBy: PropTypes.string.isRequired,
	provinceLabel: PropTypes.string,
};

export default EnhancedTableHead;



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/EnhancedTableHead.js